import { PerksState } from "./perks.types";

const state = (): PerksState => ({
  data: {},
  filters: {}
})

export default state
